//  ----------      START   IMPORT  BLOCK       ----------
import { SessionProvider } from '../API/Context/SessionContext';
import { UserProvider } from '../API/Context/UserContext';
import { LanguageProvider } from '../API/Context/LanguageContext';
import { PatientProvider } from '../API/Hooks/PatientContext';
import { ApplicationUIProvider } from '../API/Context/AppUIContext';
import { ActivePatientProvider } from '../API/Hooks/ActivePatientContext';
import { BrowserRouter } from 'react-router-dom';
import SEOHandler from '../Utils/SEOHandler';
import AppRoutes from './ApplicationRoutes';
import './App.css';
//  ----------      END   IMPORT  BLOCK       ----------

function App() {
  return (
    <UserProvider>
      <ApplicationUIProvider>
        <SessionProvider>
          <LanguageProvider>
            <PatientProvider>
              <ActivePatientProvider>
                <BrowserRouter>
                  <SEOHandler />
                  <AppRoutes />
                </BrowserRouter>
              </ActivePatientProvider>
            </PatientProvider>
          </LanguageProvider>
        </SessionProvider>
      </ApplicationUIProvider>
    </UserProvider>
  );
}

export default App;
